import React from "react";
import { motion } from "framer-motion";
import { Monogram, GoldDivider } from "./Ornaments";
import { COUPLE, FOOTER_MESSAGE } from "../lib/invitationData";

const ease = [0.22, 0.61, 0.36, 1];

export const Footer = () => {
    return (
        <footer
            id="footer"
            data-testid="site-footer"
            className="relative w-full py-28 md:py-36 paper-grain"
            style={{ backgroundColor: "#14110c" }}
        >
            <div className="max-w-2xl mx-auto px-6 text-center">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.6, ease }}
                >
                    <Monogram size={110} />
                </motion.div>

                <motion.p
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3, duration: 1.4, ease }}
                    className="mt-10 font-serif-display italic text-lg md:text-xl leading-relaxed text-[color:var(--charcoal-soft)] max-w-lg mx-auto"
                >
                    {FOOTER_MESSAGE}
                </motion.p>

                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.6, duration: 1 }}
                    className="mt-10"
                >
                    <GoldDivider />
                </motion.div>

                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.8, duration: 1 }}
                    className="mt-8 font-serif-display text-sm tracking-[0.3em] uppercase text-[color:var(--muted)]"
                >
                    Rayyan <span className="text-[color:var(--gold)]">&</span>{" "}
                    Zuha
                </motion.p>

                <p className="mt-4 text-xs tracking-[0.3em] uppercase text-[color:var(--muted)]">
                    {COUPLE.heroDate}
                </p>
            </div>
        </footer>
    );
};

export default Footer;
